import client from "services/ngage/api-client";
import DataPage from "types/DataPage";
import {queryString} from "services/string";
import {Beacon, BeaconConfiguration, BeaconData} from "types/Beacon";
import deserializeBeacon from "services/ngage/deserializers/beacon";

/**
 * Get all beacons (paginated)
 */
const all = async (page: number = 1, perPage: number = 100) => {
    const query = queryString({page, per_page: perPage})
    const response = await client.get<DataPage<Beacon> | null>(`/beacons?${query}`)

    if (response.data) {
        response.data.data = response.data.data.map(deserializeBeacon)
    }

    return response.data
}

/**
 * Get a single beacon
 *
 * @param {number} id
 */
const get = async (id: number) => {
    const response = await client.get<Beacon>(`/beacons/${id}`)
    return deserializeBeacon(response.data)
}

/**
 * Get the next beacon configuration for a site
 */
const getNextConfiguration = async () => {
    return (await client.get<BeaconConfiguration>('/beacons/next/configuration')).data || null
}

/**
 * Store a new beacon
 *
 * @param data
 */
const store = async (data: BeaconData) => {
    const response = await client.post<Beacon>('/beacons', data)
    return deserializeBeacon(response.data)
}

/**
 * Update an existing beacon
 *
 * @param {number} id
 * @param data
 */
const update = async (id: number, data: BeaconData) => {
    const response = await client.put<Beacon>(`/beacons/${id}`, data)
    return deserializeBeacon(response.data)
}

/**
 * Permanently delete a beacon
 *
 * @param {number} id
 */
const destroy = async (id: number) => {
    const response = await client.delete<null>(`/beacons/${id}`)
    return response.status === 204
}

const beacons = {
    all,
    get,
    getNextConfiguration,
    store,
    update,
    destroy
}

export default beacons;